import React from "react";
import { I18n } from "@aws-amplify/core";
import update from "immutability-helper";
import { get, map } from "lodash";

import Grid from "@material-ui/core/Grid";

import FormSection from "./FormSection";
import DatePicker from "./DatePicker";

import { nowWithOutSeconds } from "../../utils/date";

import colors from "../../assets/style/colors";

const DateFilter = (props) => {
  const { filters, setFilters, columns = false, maxPeriod, overRange } = props;

  let availablePeriods = [
    {
      name: "today",
      daysNumber: "0",
    },
    {
      name: "yesterday",
      daysNumber: 1,
    },
    {
      name: "last2days",
      daysNumber: 2,
    },
    {
      name: "last7days",
      daysNumber: 7,
    },
    {
      name: "custom",
      daysNumber: "custom",
    },
  ];

  if (!maxPeriod) {
    availablePeriods = [
      {
        name: "allTime",
        daysNumber: "allTime",
      },
      ...availablePeriods,
    ];
  }

  const handleChange = (id, index, value) => {
    if (id === "period") {
      if (value === "custom") {
        setFilters(
          update(filters, {
            dateFilter: { $set: "custom" },
            startDate: { $set: nowWithOutSeconds() - 86400000 },
            endDate: { $set: nowWithOutSeconds() },
          })
        );
      } else if (value === "allTime") {
        setFilters(
          update(filters, {
            dateFilter: { $set: value },
            startDate: { $set: null },
            endDate: { $set: null },
          })
        );
      } else {
        const now = new Date();
        const midnight = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          0,
          0,
          0
        );
        const startDate =
          value === "0"
            ? midnight.getTime()
            : new Date(midnight - 86400000 * value).getTime();
        const endDate =
          value === "0" ? midnight.getTime() + 86400000 : midnight.getTime();

        setFilters(
          update(filters, {
            dateFilter: { $set: value },
            startDate: { $set: startDate },
            endDate: { $set: endDate },
          })
        );
      }
    } else {
      setFilters(
        update(filters, {
          [id]: { $set: value },
        })
      );
    }
  };

  const handleChangeDate = (id, value) => {
    setFilters(
      update(filters, {
        [id]: { $set: new Date(value).getTime() },
      })
    );
  };

  return (
    <Grid container alignItems="center" direction={columns ? "column" : "row"}>
      <Grid item style={{ width: "200px" }}>
        <FormSection
          formValue={[get(filters, ["dateFilter"])]}
          setFormValue={handleChange}
          title={"period"}
          id={"period"}
          type="select"
          options={{
            options: map(availablePeriods, (p) => ({
              id: p.daysNumber,
              name: I18n.get(`dashboard_${p.name}`),
            })),
          }}
        />
      </Grid>
      {get(filters, ["dateFilter"]) === "custom" && (
        <>
          <Grid
            item
            style={{ margin: columns ? "" : "0px 24px", maxWidth: "200px" }}
          >
            <DatePicker
              label={I18n.get("site_startDate")}
              name="startDate"
              value={get(filters, ["startDate"])}
              onChange={handleChangeDate}
              width={200}
            />
          </Grid>
          <Grid item style={{ maxWidth: "200px" }}>
            <DatePicker
              label={I18n.get("site_endDate")}
              name="endDate"
              value={get(filters, ["endDate"])}
              onChange={handleChangeDate}
              width={200}
            />
          </Grid>
        </>
      )}
      {overRange && (
        <Grid item style={{ color: colors.threatRed }}>
          {overRange}
        </Grid>
      )}
    </Grid>
  );
};

export default DateFilter;
